import { render, staticRenderFns } from "./SearchBoxCentroResponsabilidade.vue?vue&type=template&id=7058fde0&scoped=true"
import script from "./SearchBoxCentroResponsabilidade.vue?vue&type=script&lang=js"
export * from "./SearchBoxCentroResponsabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7058fde0",
  null
  
)

export default component.exports